import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rabbitmq = defineConnector({
  identifier: "rabbitmq",
  name: "RabbitMQ",
  tagLine: "Message broker platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.rabbitmq..*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your RabbitMQ management instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "rabbitmq.your-company.com:15672",
          target: { kind: "configuration", field: "domain" },
          helperText: "Include the management API port (default: 15672).",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter credentials for a RabbitMQ user with management access. See the [API docs](https://www.rabbitmq.com/docs/management#http-api) for details.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/vhosts`,
  },
});
